/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M15 16C18.866 16 22 12.866 22 9C22 8.30503 21.8987 7.63371 21.7101 7L19.2627 9.44738C18.4707 10.2394 18.0747 10.6354 17.618 10.7838C17.2163 10.9143 16.7836 10.9143 16.3819 10.7838C15.9253 10.6354 15.5293 10.2394 14.7372 9.44738L14.2899 9"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M15 16C13.9264 16 12.4093 15.9319 11.5 15.5L5.5 21.5C5.42035 21.5797 5.38052 21.6195 5.34526 21.6515C4.58244 22.3449 3.41756 22.3449 2.65474 21.6515C2.61948 21.6195 2.57965 21.5797 2.5 21.5V21.5C2.42035 21.4203 2.38052 21.3805 2.34847 21.3453C1.65508 20.5824 1.65508 19.4176 2.34847 18.6547C2.38052 18.6195 2.42035 18.5797 2.5 18.5L8.5 12.5C8.06806 11.5907 8 10.0736 8 9C8 5.13401 11.134 2 15 2C15.695 2 16.3663 2.10128 17 2.28988L14.2899 5C13.7446 5.54525 13.472 5.81787 13.3263 6.11197C13.049 6.67152 13.049 7.32848 13.3263 7.88803C13.472 8.18213 13.7446 8.45475 14.2899 9V9L15 9.71012"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path
				opacity="0.12"
				d="M15 16C18.866 16 22 12.866 22 9C22 8.30503 21.8987 7.63371 21.7101 7L19.2627 9.44738L19.2627 9.4474C18.4707 10.2394 18.0747 10.6354 17.618 10.7838C17.2163 10.9143 16.7837 10.9143 16.382 10.7838C15.9253 10.6354 15.5293 10.2394 14.7373 9.44738L14.5526 9.26274C13.7606 8.47071 13.3646 8.07469 13.2162 7.61803C13.0857 7.21635 13.0857 6.78365 13.2162 6.38197C13.3646 5.92531 13.7606 5.52929 14.5526 4.73726L17 2.28988C16.3663 2.10128 15.695 2 15 2C11.134 2 8 5.13401 8 9C8 10.0736 8.06806 11.5907 8.5 12.5L2.5 18.5L2.49986 18.5001C2.4203 18.5797 2.3805 18.6195 2.34847 18.6547C1.65508 19.4176 1.65508 20.5824 2.34847 21.3453C2.3805 21.3805 2.4203 21.4203 2.49987 21.4999L2.5 21.5C2.57965 21.5797 2.61948 21.6195 2.65474 21.6515C3.41756 22.3449 4.58244 22.3449 5.34526 21.6515C5.38052 21.6195 5.42035 21.5797 5.5 21.5L11.5 15.5C12.4093 15.9319 13.9264 16 15 16Z"
				fill="currentColor"
			/>
			<path
				d="M15 16C18.866 16 22 12.866 22 9C22 8.30503 21.8987 7.63371 21.7101 7L19.2627 9.44738L19.2627 9.4474C18.4707 10.2394 18.0747 10.6354 17.618 10.7838C17.2163 10.9143 16.7837 10.9143 16.382 10.7838C15.9253 10.6354 15.5293 10.2394 14.7373 9.44738L14.5526 9.26274C13.7606 8.47071 13.3646 8.07469 13.2162 7.61803C13.0857 7.21635 13.0857 6.78365 13.2162 6.38197C13.3646 5.92531 13.7606 5.52929 14.5526 4.73726L17 2.28988C16.3663 2.10128 15.695 2 15 2C11.134 2 8 5.13401 8 9C8 10.0736 8.06806 11.5907 8.5 12.5L2.5 18.5L2.49986 18.5001C2.4203 18.5797 2.3805 18.6195 2.34847 18.6547C1.65508 19.4176 1.65508 20.5824 2.34847 21.3453C2.3805 21.3805 2.4203 21.4203 2.49987 21.4999L2.5 21.5C2.57965 21.5797 2.61948 21.6195 2.65474 21.6515C3.41756 22.3449 4.58244 22.3449 5.34526 21.6515C5.38052 21.6195 5.42035 21.5797 5.5 21.5L11.5 15.5C12.4093 15.9319 13.9264 16 15 16Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<g clipPath="url(#clip0_2004_8842)">
				<path
					d="M15.0001 1.25C10.7198 1.25 7.25005 4.71979 7.25005 9C7.25005 9.54962 7.2673 10.2289 7.34284 10.896C7.39227 11.3326 7.41699 11.5509 7.41932 11.6364C7.43566 12.236 7.33622 12.5204 6.94987 12.9792C6.89476 13.0446 6.79684 13.1426 6.60098 13.3384L1.96972 17.9697C0.848402 19.091 0.848402 20.909 1.96972 22.0303C3.09104 23.1516 4.90906 23.1517 6.03038 22.0303L10.6616 17.3991C10.8575 17.2032 10.9554 17.1053 11.0209 17.0502C11.4796 16.6638 11.7641 16.5644 12.3636 16.5807C12.4491 16.5831 12.6674 16.6078 13.104 16.6572C13.7712 16.7328 14.4504 16.75 15.0001 16.75C19.2803 16.75 22.7501 13.2802 22.7501 9C22.7501 8.62484 22.7233 8.25547 22.6716 7.8938L22.4593 6.40925L19.8723 8.99621C19.0803 9.78825 18.6842 10.1843 18.2276 10.3326C17.8259 10.4632 17.3932 10.4632 16.9915 10.3326C16.5349 10.1843 16.1388 9.78825 15.3468 8.99621L15.0038 8.65325C14.2118 7.86121 13.8158 7.4652 13.6674 7.00854C13.5369 6.60685 13.5369 6.17416 13.6674 5.77247C13.8158 5.31581 14.2118 4.9198 15.0038 4.12776L17.5908 1.54079L16.1063 1.32845C15.7446 1.27671 15.3752 1.25 15.0001 1.25Z"
					fill="currentColor"
				/>
			</g>
			<defs>
				<clipPath id="clip0_2004_8842">
					<rect width="24" height="24" fill="white" />
				</clipPath>
			</defs>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M9.25469 5C8.46381 6.13383 8 7.51275 8 9C8 10.0736 8.06806 11.5907 8.5 12.5L2.5 18.5C2.42035 18.5797 2.38052 18.6195 2.34847 18.6547C1.65508 19.4176 1.65508 20.5824 2.34847 21.3453C2.38052 21.3805 2.42035 21.4203 2.5 21.5V21.5C2.57965 21.5797 2.61948 21.6195 2.65474 21.6515C3.41756 22.3449 4.58244 22.3449 5.34526 21.6515C5.38052 21.6195 5.42035 21.5797 5.5 21.5L11.5 15.5C12.4093 15.9319 13.9264 16 15 16C18.866 16 22 12.866 22 9C22 8.30503 21.8987 7.63371 21.7101 7L19.2627 9.44738C18.4707 10.2394 18.0747 10.6354 17.618 10.7838C17.2163 10.9143 16.7837 10.9143 16.382 10.7838C15.9253 10.6354 15.5293 10.2394 14.7373 9.44738L14.5526 9.26274C13.7606 8.47071 13.3646 8.07469 13.2162 7.61803C13.0857 7.21635 13.0857 6.78365 13.2162 6.38197C13.3646 5.92531 13.7606 5.52929 14.5526 4.73726L17 2.28988C16.3663 2.10128 15.695 2 15 2C13.9264 2 12.9093 2.24169 12 2.67363"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M15 16C18.866 16 22 12.866 22 9C22 8.30503 21.8987 7.63371 21.7101 7L19.2627 9.44738L19.2627 9.4474C18.4707 10.2394 18.0747 10.6354 17.618 10.7838C17.2163 10.9143 16.7837 10.9143 16.382 10.7838C15.9253 10.6354 15.5293 10.2394 14.7373 9.44738L14.5526 9.26274C13.7606 8.47071 13.3646 8.07469 13.2162 7.61803C13.0857 7.21635 13.0857 6.78365 13.2162 6.38197C13.3646 5.92531 13.7606 5.52929 14.5526 4.73726L17 2.28988C16.3663 2.10128 15.695 2 15 2C11.134 2 8 5.13401 8 9C8 10.0736 8.06806 11.5907 8.5 12.5L2.5 18.5L2.49986 18.5001C2.4203 18.5797 2.3805 18.6195 2.34847 18.6547C1.65508 19.4176 1.65508 20.5824 2.34847 21.3453C2.3805 21.3805 2.4203 21.4203 2.49987 21.4999L2.5 21.5C2.57965 21.5797 2.61948 21.6195 2.65474 21.6515C3.41756 22.3449 4.58244 22.3449 5.34526 21.6515C5.38052 21.6195 5.42035 21.5797 5.5 21.5L11.5 15.5C12.4093 15.9319 13.9264 16 15 16Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<g clipPath="url(#clip0_2004_8839)">
				<path
					opacity="0.32"
					d="M15 1.25C10.7198 1.25 7.24999 4.71979 7.24999 9C7.24999 9.54962 7.26724 10.2289 7.34278 10.896C7.39221 11.3326 7.41692 11.5509 7.41926 11.6364C7.4356 12.236 7.33616 12.5204 6.94981 12.9792C6.8947 13.0446 6.79678 13.1426 6.60092 13.3384L1.96966 17.9697C0.848341 19.091 0.848341 20.909 1.96966 22.0303C3.09098 23.1516 4.909 23.1517 6.03032 22.0303L10.6616 17.3991C10.8574 17.2032 10.9554 17.1053 11.0208 17.0502C11.4796 16.6638 11.764 16.5644 12.3636 16.5807C12.4491 16.5831 12.6674 16.6078 13.104 16.6572C13.7711 16.7328 14.4504 16.75 15 16.75C19.2802 16.75 22.75 13.2802 22.75 9C22.75 8.62484 22.7233 8.25547 22.6715 7.8938L22.4592 6.40925L19.8722 8.99621C19.0802 9.78825 18.6842 10.1843 18.2275 10.3326C17.8258 10.4632 17.3931 10.4632 16.9915 10.3326C16.5348 10.1843 16.1388 9.78825 15.3467 8.99621L15.0038 8.65325C14.2117 7.86121 13.8157 7.4652 13.6673 7.00854C13.5368 6.60685 13.5368 6.17416 13.6673 5.77247C13.8157 5.31581 14.2117 4.9198 15.0038 4.12776L17.5907 1.54079L16.1062 1.32845C15.7445 1.27671 15.3752 1.25 15 1.25Z"
					fill="currentColor"
				/>
				<path
					d="M4.90916 15.0303L1.96965 17.9698C0.848334 19.0911 0.848333 20.9091 1.96965 22.0304C3.09097 23.1518 4.909 23.1517 6.03031 22.0304L8.96978 19.0908C10.091 17.9695 10.091 16.1516 8.96974 15.0303C7.84845 13.909 6.03046 13.909 4.90916 15.0303Z"
					fill="currentColor"
				/>
			</g>
			<defs>
				<clipPath id="clip0_2004_8839">
					<rect width="24" height="24" fill="white" />
				</clipPath>
			</defs>
		</Fragment>,
	],
]);
